var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4953 14.4996C34.2308 18.1091 33.7066 21.8617 32.0102 25.1315C30.3138 28.4014 27.5477 30.9908 24.1732 32.468C20.7986 33.9453 17.0197 34.221 13.4665 33.2492C9.91329 32.2774 6.80062 30.1169 4.64757 27.1279C2.49452 24.1389 1.43124 20.5022 1.63503 16.8241C1.83882 13.1461 3.29737 9.64906 5.76745 6.91624C8.23752 4.18342 11.5698 2.38 15.2086 1.80671C18.8474 1.23342 22.5728 1.92493 25.7635 3.76591",
    stroke: "#00C950",
    strokeWidth: 3.22092,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8804 16.1101L17.7117 20.9415L33.8163 4.83688",
    stroke: "#00C950",
    strokeWidth: 3.22092,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/Icon_success.9c1bc3c44df67c4fd0a0689a4f1f4b7f.svg";
export { ForwardRef as ReactComponent };